import React from 'react';
import { Link } from 'react-router-dom';
import { useSEO } from '../hooks/useSEO';

export default function NotFound() {
  useSEO({
    title: 'Siden blev ikke fundet · Vissenbjerg Bageri',
    description: 'Siden du leder efter, findes desværre ikke. Gå tilbage til forsiden og find vores lækre udvalg af brød og kager.'
  });

  return (
    <div className="bg-transparent text-chocolate min-h-[70vh] flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="text-center max-w-md space-y-6">
        <div className="text-gold-brown text-7xl">
          <i className="fa-solid fa-cookie-bite animate-bounce" />
        </div>
        <h1 className="font-serif text-4xl font-bold text-chocolate sm:text-5xl">
          404 - Siden mangler
        </h1>
        <p className="text-base text-chocolate/80 leading-relaxed">
          Hovsa! Det ser ud til, at denne side er blevet spist, eller måske har vi aldrig bagt den. Lad os guide dig tilbage til duften af friskbagt brød.
        </p>
        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-gold-brown px-6 py-3 text-sm font-semibold text-cream hover:bg-copper transition-colors duration-200 shadow-md"
          >
            <i className="fa-solid fa-house" /> Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  );
}
